import { CartBuyer } from '@/models/cart';
import { Company } from '@/models/company';

export function isCompanyOnPayments(
  company?: Pick<Company | CartBuyer, 'enablePaymentsDirect' | 'enablePaymentsFlexible'>,
) {
  return company?.enablePaymentsDirect || company?.enablePaymentsFlexible;
}
